if (!customElements.get('recommended-products')) {
  class RecommendedProducts extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
    }

    connectedCallback() {
      // ARTMIE_LAZY_CAROUSEL v2 2026-06-26: init Swiper near viewport (mobile INP); guaranteed setTimeout fallback so init can never be skipped.
      var self = this;
      var start = function(){ if (typeof Swiper !== 'undefined') { self.initSwiper(); } else { setTimeout(start, 100); } };
      var go = function(){ if (self.__armieInit) return; self.__armieInit = true; if (self.__armieIO) self.__armieIO.disconnect(); start(); };
      if ('IntersectionObserver' in window) {
        self.__armieIO = new IntersectionObserver(function(en){ for (var i=0;i<en.length;i++){ if(en[i].isIntersecting){ go(); break; } } }, { rootMargin: '600px 0px' });
        self.__armieIO.observe(self);
      }
      setTimeout(go, 2500);
    }

    initSwiper() {
      const slider = this.querySelector('.swiper');
      if (!slider || this.swiperInstance) return;

      const nextButton = this.querySelector('.swiper-button-next');
      const prevButton = this.querySelector('.swiper-button-prev');
      const pagination = this.querySelector('.swiper-pagination');

      // Get settings from data attributes
      const desktopColumns = parseFloat(this.dataset.desktopColumns) || 4;
      const mobileColumns = parseFloat(this.dataset.mobileColumns) || 1.2;
      const gap = parseInt(this.dataset.gap) || 24;
      const gapMobile = parseInt(this.dataset.gapMobile) || 16;

      this.swiperInstance = new Swiper(slider, {
        slidesPerView: mobileColumns,
        spaceBetween: gapMobile,
        loop: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: pagination,
          clickable: true,
          type: 'bullets',
          dynamicBullets: false,
        },
        breakpoints: {
          640: { 
            slidesPerView: Math.min(desktopColumns, 2), 
            spaceBetween: gap 
          },
          768: { 
            slidesPerView: Math.min(desktopColumns, 3), 
            spaceBetween: gap 
          },
          1024: { 
            slidesPerView: desktopColumns, 
            spaceBetween: gap 
          }
        },
        on: {
          init: function() {
            console.log('Recommended Products Swiper initialized');
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }
  }

  customElements.define('recommended-products', RecommendedProducts);
}
